import { useState, useEffect } from 'react';

function useFormatText(text) {
    const [formattedText, setFormattedText] = useState([]);

    useEffect(() => {
        if (!text) {
            setFormattedText([]);
            return;
        }

        // 1. Remplace **gras** ET [b]gras[/b] par <strong>
        let processedText = text.replace(/\*\*(.*?)\*\*|\[b\](.*?)\[\/b\]/g, '<strong>$1$2</strong>');

        // 2. Sépare les lignes et ajoute des <br />
        const lines = processedText.split('\n').map((line, index) => (
            <span key={index} dangerouslySetInnerHTML={{ __html: line }} />
        ));

        // 3. Ajoute des <br /> entre les lignes (sauf après la dernière)
        const result = [];
        lines.forEach((line, index) => {
            result.push(line);
            if (index < lines.length - 1) {
                result.push(<br key={`br-${index}`} />);
            }
        });

        setFormattedText(result);
    }, [text]);

    return formattedText;
}

export default useFormatText;